module.exports = __webpack_public_path__ + "static/media/0042.2d29e540.svg";